export const GET_CAMPOS_DINAMICOS = 'deca.GET_CAMPOS_DINAMICOS';
export const SET_CAMPOS_DINAMICOS = 'deca.SET_CAMPOS_DINAMICOS';
export const RESETFORM = 'deca.RESETFORM';
